// extracted by mini-css-extract-plugin
module.exports = {"single-page-container":"SinglePageSpread_single-page-container__3H-5g","single-page":"SinglePageSpread_single-page__1BqB5"};